import { Badge, BlockStack, Card, Icon, InlineStack, Text, Tooltip } from "@shopify/polaris";
import { InfoIcon } from "@shopify/polaris-icons";

interface MetricCardProps {
  currency?: null | string;
  title: string;
  tooltip: string;
  value: null | number | string | undefined;
}

export const MetricCard = ({ currency, title, tooltip, value }: MetricCardProps) => {
  return (
    <Card>
      <BlockStack gap="200">
        <InlineStack gap="150">
          <Text as="h2" variant="headingMd">
            {title}
          </Text>
          {tooltip && (
            <Tooltip content={tooltip} width="wide">
              <Icon source={InfoIcon} />
            </Tooltip>
          )}
        </InlineStack>
        {value !== null && value !== undefined && value !== 0 ? (
          <Text as="p" variant="headingLg">
            {value}{" "}
            {currency && (
              <Text as="span" variant="bodyMd">
                {currency}
              </Text>
            )}
          </Text>
        ) : (
          <div>
            <Badge>Insufficient data</Badge>
          </div>
        )}
      </BlockStack>
    </Card>
  );
};
